export default __webpack_public_path__ + "assets/reset.a95bd721067026b679753b766d03f4a5.svg";